import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPage } from '@tecma/ds';
import { logger } from '@tecma/logs-fe';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Tracking from 'components/Tracking/Tracking';
import { getProjectLogoUrl } from 'utils/project';
import { getLanguageFromQueryParams } from 'utils';
import { Providers } from 'components/Providers/Providers';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);
const currentLanguage = getLanguageFromQueryParams() ?? localStorage.getItem('i18nextLng') ?? undefined;

root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={() => <ErrorPage logo={getProjectLogoUrl()} language={currentLanguage} />}
      onError={(error) => {
        logger.error('APPLICATION_ERROR', { error });
      }}
    >
      <Providers>
        <Tracking />
        <App />
      </Providers>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
